import {Component, OnInit} from '@angular/core';
import {UserRepository} from './modules/user/states/user.repository';
import {AuthService} from './shared/services/auth.service';
import {filter, take} from 'rxjs';
import {AppDataLoadService} from './shared/services/app-data-load.service';
import {AppRoutingModule} from "./app-routing.module";
import {LayoutModule} from "./layout/layout.module";
import {ModulesModule} from "./modules/modules.module";
import {SharedModule} from "./shared/shared.module";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {CommonModule} from "@angular/common";
import {NavigationEnd, Router, RouterModule} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    AppRoutingModule,
    LayoutModule,
    ModulesModule,
    SharedModule,
    ConfirmDialogModule,
  ]
})
export class AppComponent implements OnInit {
  isAppLoading = true;

  constructor(
    private readonly _userRepository: UserRepository,
    private readonly _authService: AuthService,
    private readonly _appDataLoadService: AppDataLoadService,
    private readonly _router: Router,
  ) {
  }

  ngOnInit(): void {
    const loader = document.getElementById('initial-loader');
    if (loader) {
      loader.remove();
    }
    this._userRepository.getActiveUser().pipe(take(1)).subscribe((user) => {
      if (!user) {
        this._authService.loadUser();
        void this._appDataLoadService.loadAppData();
      }
    });

    document.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    });

    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      take(1)
    ).subscribe(() => {
      this.isAppLoading = false;
    });
  }
}
